module.exports = require("./crossfilter").crossfilter;



//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/node_modules/crossfilter2/index.js
// module id = 1900
// module chunks = 7